var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"bread-crumbs"},_vm._l((_vm.crumbs),function({ title, path },index){return _c('li',{key:index,staticClass:"bread-crumbs__item"},[_c('router-link',{staticClass:"bread-crumbs__link",attrs:{"to":path}},[_vm._v(" "+_vm._s(title)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }